import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useContext } from 'react';
import DataLayerContext from '../contexts/data-layer.js';
import DataLayerScopeContext from '../contexts/data-layer-scope.js';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var useDataLayer = function useDataLayer(initialContext) {
  var _useContext = useContext(DataLayerContext),
      handleMessage = _useContext.handleMessage;

  var scope = useContext(DataLayerScopeContext);

  var pushDataLayerMessage = function pushDataLayerMessage(selector, context) {
    var trigger = 'event';
    context = _objectSpread(_objectSpread({}, initialContext), context);

    if (scope) {
      selector = scope.wrapSelector(selector);
      context = scope.wrapContext(context);
    }

    handleMessage({
      trigger: trigger,
      selector: selector,
      context: context
    });
  };

  return {
    pushDataLayerMessage: pushDataLayerMessage
  };
};

export { useDataLayer as default };